import { SEED_STATS } from 'Data/stats'
import { StatItem } from 'Models'

const STORAGE_KEY = 'landing-page:stats:v1'
const SIMULATED_LATENCY_MS = 500

const wait = (ms: number) =>
  new Promise<void>((resolve) => {
    setTimeout(resolve, ms)
  })

function isStatList(value: unknown): value is StatItem[] {
  return (
    Array.isArray(value) &&
    value.every(
      (entry) =>
        typeof entry === 'object' &&
        entry !== null &&
        typeof (entry as StatItem).id === 'string' &&
        typeof (entry as StatItem).number === 'string' &&
        typeof (entry as StatItem).description === 'string' &&
        typeof (entry as StatItem).visible === 'boolean',
    )
  )
}

export async function fetchStats(): Promise<StatItem[]> {
  await wait(SIMULATED_LATENCY_MS)

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (raw) {
      const parsed: unknown = JSON.parse(raw)
      if (isStatList(parsed)) {
        return parsed
      }
    }
  } catch {
    // Corrupt or inaccessible storage: fall back to the seed data.
  }

  return SEED_STATS.map((item) => ({ ...item }))
}

export async function publishStats(items: StatItem[]): Promise<StatItem[]> {
  await wait(SIMULATED_LATENCY_MS)
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items))
  return items
}
